import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivityPlayerComponent } from '../activity-player/activity-player.component';
import { ImmersionCourseService } from '../immersion-course.service';
import { CourseContentType } from '../types/course-content-type';
import { StudyBundleCourseDto } from '../types/StudyBundleCourseDto';

@Component({
  selector: 'lp2-industry-content-modal-player',
  templateUrl: './industry-content-modal.component.html',
  styleUrls: ['./industry-content-modal.component.scss'],
})
export class IndustryContentModalComponent {
  @Input() course: StudyBundleCourseDto;
  @Input() shouldSaveTime = false;
  @ViewChild(ActivityPlayerComponent) player: ActivityPlayerComponent;

  startTime = 0;
  isComplete = false;
  isIndexVisible = false;

  constructor(
    public activeModal: NgbActiveModal,
    private immersionCourseService: ImmersionCourseService
  ) {}

  toggleIndex() {
    this.isIndexVisible = !this.isIndexVisible;
    this.player.toggleIndex();
  }

  setStartTime() {
    this.startTime = Math.floor(Date.now() / 1000);
  }

  close() {
    this.activeModal.close();
    this.saveActivity();
  }

  private saveActivity() {
    if (
      !this.shouldSaveTime ||
      !this.course ||
      !this.course.id ||
      !this.startTime
    ) {
      return;
    }

    const timeOntask = this.immersionCourseService.calculateTimeOnTask(
      this.startTime
    );
    this.immersionCourseService
      .savePersonCourse(
        timeOntask,
        this.isComplete,
        this.course.id,
        CourseContentType.ISC
      )
      .subscribe();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/industry-content-modal/industry-content-modal.component.ts